/**
 * Bank-transfer account shown in the bank-details dialog.
 * ADHA Pay Now reads profile-details `bank_details`.
 * Owned-unit View Bank Details reads the installment entry's `bank_details`.
 */

export interface BankTransferAccount {
  accountName: string;
  bankName: string;
  accountNumber: string;
  iban: string;
  swiftCode: string;
}

function trimText(value: unknown): string {
  if (typeof value !== 'string') {
    return '';
  }
  return value.trim();
}

export function mapStoreBankDetailsToAccount(params: {
  accountName: unknown;
  bankName: unknown;
  accountNumber: unknown;
  iban: unknown;
  swiftCode: unknown;
}): BankTransferAccount | null {
  const account: BankTransferAccount = {
    accountName: trimText(params.accountName),
    bankName: trimText(params.bankName),
    accountNumber: trimText(params.accountNumber),
    iban: trimText(params.iban),
    swiftCode: trimText(params.swiftCode),
  };
  const hasAny = Object.values(account).some((value) => value.length > 0);
  return hasAny ? account : null;
}

/** Map one unit-installments `bank_details` block onto the dialog account. */
export function mapInstallmentBankDetailsToAccount(
  bank: {
    beneficiary_name?: string | null;
    bank_name?: string | null;
    account_number?: string | null;
    IBAN_number?: string | null;
    swift_code?: string | null;
  } | null | undefined,
): BankTransferAccount | null {
  if (!bank) {
    return null;
  }
  return mapStoreBankDetailsToAccount({
    accountName: bank.beneficiary_name,
    bankName: bank.bank_name,
    accountNumber: bank.account_number,
    iban: bank.IBAN_number,
    swiftCode: bank.swift_code,
  });
}
